import { sortBy } from 'lodash';

export const getSortedSubcategories = state => {
  const { subcategories } = state.subcategoryDropdown;
  return sortBy(subcategories, ({ name }) => name);
};

export const getSubcategoryDropdownSearchTerm = state =>
  state.subcategoryDropdown.searchTerm;
